import { Guid } from '../../types/identifiers/guid';

export type AudioAsset = {
  track: AudioTrack;
  subtitles: AudioSubtitles | null;
};

export type VoiceOver = {
  text: string;
  language: string;
  voiceId: string;
};

export type AudioTrack = {
  assetGuid: Guid;
  voiceOverData?: VoiceOver;
};

export type AudioSubtitles = {
  assetGuid: Guid;
};

export enum RestrictionType {
  none = 'none',
  customTime = 'customTime',
  audioDuration = 'audioDuration',
}

export type CustomTimeNavigationRestriction = {
  restrictionType: RestrictionType.customTime;
  duration: number;
};

export type AudioDurationNavigationRestriction = {
  restrictionType: RestrictionType.audioDuration;
  duration?: never;
};

export type NoNavigationRestriction = {
  restrictionType: RestrictionType.none;
  duration?: never;
};

export type NavigationRestriction =
  | CustomTimeNavigationRestriction
  | AudioDurationNavigationRestriction
  | NoNavigationRestriction;

export type NavigationRestrictionWithAutoProgress =
  | ((CustomTimeNavigationRestriction | AudioDurationNavigationRestriction) & {
      autoProgress: boolean;
    })
  | (NoNavigationRestriction & { autoProgress?: never });

export const DefaultRestriction: NoNavigationRestriction = {
  restrictionType: RestrictionType.none,
};

export function createCustomTimeRestriction(duration: number): CustomTimeNavigationRestriction;
export function createCustomTimeRestriction(
  duration: number,
  autoProgress: boolean
): NavigationRestrictionWithAutoProgress;
export function createCustomTimeRestriction(
  duration: number,
  autoProgress?: boolean
): NavigationRestrictionWithAutoProgress | CustomTimeNavigationRestriction {
  return {
    restrictionType: RestrictionType.customTime,
    duration,
    autoProgress: autoProgress ?? false,
  };
}

export function createAudioRestriction(): NavigationRestriction;
export function createAudioRestriction(autoProgress: boolean): NavigationRestrictionWithAutoProgress;
export function createAudioRestriction(
  autoProgress?: boolean
): NavigationRestriction | NavigationRestrictionWithAutoProgress {
  return {
    restrictionType: RestrictionType.audioDuration,
    autoProgress: autoProgress ?? false,
  };
}

export enum ModalSize {
  Fullscreen = 'Fullscreen',
  Small = 'Small',
  Sidebar = 'Sidebar',
}

export enum ItemType {
  Hotspot = 'hotspot',
  SequencedFlowStep = 'sequencedFlowStep',
}
